import {
    VALIDATE_BILLTO,
    VALIDATE_BILLTO_SUCCESS,
    VALIDATE_BILLTO_FAILURE,
    RESET_VALIDATE_BILLTO,
    CLEAR_CALLTYPE,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    validateBillTo: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    validateBillToLoading: false,
};

const validateBillToReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATE_BILLTO:
            return {
                ...state,
                validateBillToLoading: true,
            };
        case VALIDATE_BILLTO_SUCCESS: 
            return {
                ...state,
                validateBillTo: {
                    data: action.data,
                    statusCode: '10001',
                },
                validateBillToLoading: false,
            };
        case VALIDATE_BILLTO_FAILURE:
            return {
                ...state,
                validateBillTo: {
                    data: {},
                    message: action.stausMessage,
                    statusCode: '422',
                },
                validateBillToLoading: false,
            };
        case RESET_VALIDATE_BILLTO:
            return {
                ...initialState,
            };
        case CLEAR_CALLTYPE:
            return{
                ...state,
                validateBillTo:{
                    ...state.validateBillTo,
                    [action.payload.callType]: false
                }
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'surgeryValidateAccountKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    validateBillToReducer
);
